module.exports = __webpack_public_path__ + "img/TW.3c30dfe3.png";